import * as AppState from '../../../../../../store/app.state';
import * as assignmentsActions from '../action/units-statistics-assignments.actions';
import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';

/**
 * assignment reducer used to updated store values based on certain action.
 */

/**
 * State interface extends App state State and add user state to the main state.
 */
export interface State extends AppState.State {
   assignmentsStatistics: assignmentsStatisticsState;
}

/**
 * An SubjectState interface, which represents the blueprint of the User State.
 */
export interface assignmentsStatisticsState {
   assignmentsStatistics: any;
   assignmentsNumber: number;
   errorMessage: string;
}

/**
 * SubjectState initial state.
 */
export const initialState: assignmentsStatisticsState = {
   assignmentsStatistics: null,
   assignmentsNumber: null,
   errorMessage: null,
};

/**
 * Subject Reducer used to update the state upon Subject actions.
 */
export const assignmentsStatisticsReducer = createReducer(
   initialState,
   /**
    * On loadSubjectsDetailsSuccess action updated current state with the following properties.
    */
   on(
      assignmentsActions.loadUnitsStatisticsAssignmentsSuccess,
      (state, action): assignmentsStatisticsState => {
         return {
            ...state,
            assignmentsStatistics: action.data.assignmentsDetails,
            assignmentsNumber: action.data.assignmentsNumber,
         };
      }
   ),

   /**
    * On loadSubjectsDetailsFailure action updated current state with the following properties.
    */
   on(
      assignmentsActions.loadUnitsStatisticsAssignmentsFailure,
      (state, action): assignmentsStatisticsState => {
         return {
            ...state,
            errorMessage: action.error,
         };
      }
   )
);
